import _ from 'lodash';
import { NAME } from './constants';

export const getAuthorizeToken = state => _.get(state[NAME], 'token');
export const getAuthorizeTokenTtl = state => _.get(state[NAME], 'tokenTtl');
export const getRedirectToOld = state => _.get(state[NAME], 'redirectToOld');
export const isAuthorizing = state => _.get(state[NAME], 'authorizing');